import Notification from '@web/shared-digital-library/vue-components/Global/atoms/Notification.vue';
export default {
  components: {
    Notification
  },

  data() {
    return {
      displayNotification: false,
      notificationMessage: '',
      notificationType: ''
    };
  },

  created() {
    this.$root.$on('notification', (_ref) => {
      let {
        message,
        type
      } = _ref;
      this.displayNotification = true;
      this.notificationMessage = message;
      this.notificationType = type;
      window.setTimeout(() => {
        this.displayNotification = false;
        this.notificationMessage = '';
        this.notificationType = '';
      }, 5000);
    });
  },

  beforeDestroy() {
    this.$root.$off('notification');
  }

};